if (document.body.classList.contains("home")) {
    const whitebgs = document.querySelector(".whitebgs");
    const children = document.querySelectorAll("span.whitebg");

    children.forEach((child) => {
        const clone = child.cloneNode(true);

        const updatePosition = () => {
            const rect = child.getBoundingClientRect();
            const scrollY = window.scrollY || window.pageYOffset;
            clone.style.position = "absolute";
            clone.style.left = `${rect.left}px`;
            clone.style.top = `${rect.top + scrollY}px`;
            clone.style.width = `${rect.width}px`;
            clone.style.height = `${rect.height}px`;
        };

        let resizeTimeout;

        updatePosition();

        resizeTimeout = setTimeout(() => {
            updatePosition();
        }, 600);

        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            updatePosition();
            resizeTimeout = setTimeout(() => {
                updatePosition();
            }, 1000);
        });

        whitebgs.appendChild(clone);
    });

    const pickup = document.querySelector("#pickup");

    const scroll = () => {
        if (pickup.getBoundingClientRect().bottom < innerHeight) {
            pickup.classList.add("is-ended");
        } else {
            pickup.classList.remove("is-ended");
        }
    };
    scroll();
    window.addEventListener("scroll", scroll);
}
